<div class="splash" [class.finished]="finished">
  <div class="words" [class.combined]="combined">
    <span class="word" [class.visible]="showLegends">Legends</span>
    <span class="word" [class.visible]="showNever">Don't</span>
    <span class="word" [class.visible]="showLayup">Layup</span>
  </div>
</div>
